import * as React from 'react'
import {
  buildTimeSlots,
  MuiDatePickerFormik,
  TimePicker,
} from '@user/components/Formik'
import { Field } from 'formik'
import { useDueDateManagement } from '../hooks'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

const timeSlots = buildTimeSlots(15, 1, 24)

export function DueDatePicker() {
  const { timeDisabled } = useDueDateManagement()

  return (
    <Stack>
      <Typography variant="body1" mt={1} mb={1} fontSize={16}>
        Due Date*
      </Typography>
      <Stack spacing={1} direction="row" alignItems="start">
        <Field
          name="dueDate"
          component={MuiDatePickerFormik}
          tidalAdditionalStyling
          fullWidth
          size="medium"
          inputProps={{ 'data-test-id': 'dueDate' }}
        />
        <TimePicker
          fullWidth
          name="dueTime"
          label=""
          allowUnlistedTimes
          timeSlots={timeSlots}
          size="small"
          disabled={timeDisabled}
          placeholder="Time"
          testId="dueTime"
          tidalAdditionalStyling
        />
      </Stack>
    </Stack>
  )
}
